export default {
  /**
   *
   * @param {*} key
   * @param {*} defaultValue
   * @returns
   */
  getItem(key, defaultValue) {
    let valueStr = localStorage.getItem(key);
    if (valueStr) {
      try {
        return JSON.parse(valueStr);
      } catch (e) {
        console.warn(`localStorage got no value for ${key}`);
      }
    }
    return defaultValue;
  },

  getUserStates() {
    return this.getItem('userStates', {});
  },
  setUserStates(userStateType, userStatesArray) {
    this.setItem('userStates', userStateType, userStatesArray);
  },
  /**
   *
   * @param {*} key
   * @param {*} property
   * @param {*} value
   */
  setItem(key, property, value) {
    let item = this.getItem(key, {});
    item[property] = value;
    localStorage.setItem(key, JSON.stringify(item));
  },

  addUserState(item) {
    let userStates = this.getItem('userStates', {});
    let thisItemUserStates = userStates[item._userState._type] || [];

    let userStateItemExists = false;
    for (let userStateItem of thisItemUserStates) {
      if (userStateItem.fileIdFk === item._userState.fileIdFk) {
        if (!userStateItem.dateread && item._userState.dateread) {
          userStateItem.dateread = item._userState.dateread;
          userStateItem.userdatemodified = item._userState.userdatemodified;
        }
        if (!userStateItem.dateconfirmed && item._userState.dateconfirmed) {
          userStateItem.dateconfirmed = item._userState.dateconfirmed;
          userStateItem.userdatemodified = item._userState.userdatemodified;
        }
        userStateItemExists = true;
      }
    }
    if (!userStateItemExists) {
      thisItemUserStates.push(item._userState);
    }

    this.setItem('userStates', item._userState._type, thisItemUserStates);
  },
};
